import React from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { selectDirection } from "styles/theme/slice";
import useQueryRefNav from "utils/user-ref-nav-query";
import Details from "./components/Details";
import List from "./components/List";
interface Props {}

const Users = (props: Props) => {
  const direction = useSelector(selectDirection);

  const isResetRequired = useQueryRefNav();
  return (
    <div dir={direction}>
      <Routes>
        <Route path="/" element={<List isResetRequired={isResetRequired} />} />
        <Route path=":id/view" element={<Details mode="view" />} />
        <Route path="new" element={<Details mode="new" />} />
        <Route path=":id/edit" element={<Details mode="edit" />} />
      </Routes>
    </div>
  );
};

export default Users;
